// extracted by mini-css-extract-plugin
export default {"brass-plitter-spliter":"Viewer_brass-plitter-spliter__OT3mQ","brass-plitter-spliter-loading":"Viewer_brass-plitter-spliter-loading__plxbj"};